import { IS_BROWSER } from '~/client/constants'

export const initScrollRestoration = (): void => {
  if (IS_BROWSER && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
}
